module.exports = __webpack_public_path__ + "static/img/PK.c4f9bbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/PK.jpg
// module id = 0OUM
// module chunks = 0